export const CRYSTALLIZE_CUSTOMER_META_MOLLIE_ID_KEY = 'Mollie Customer Id';
export const CRYSTALLIZE_CUSTOMER_META_MOLLIE_PREFERRED_MANDATE_ID_KEY =
  'Mollie Preferred Mandate Id';
export const CRYSTALLIZE_CUSTOMER_META_NUKI_CLUB_KEY = 'Nuki Club';
export const CRYSTALLIZE_CUSTOMER_META_INITIAL_EMAIL_HASHED = 'Initial Email Hashed';
export const CRYSTALLIZE_CUSTOMER_EXTERNAL_REFERENCES_EMAIL_KEY = 'Email';
export const CRYSTALLIZE_CUSTOMER_EXTERNAL_REFERENCES_ORY_ID_KEY = 'Ory Id';
export const CRYSTALLIZE_ADDRESS_META_COMPANY_KEY = 'Company';
